import React, { FC, useState, useEffect } from 'react'
import { getSemesterCourseReport } from '../semestercoursereport/list/core/_requests'
import { getSurvey } from '../survey/list/core/_requests'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import SurveyResultsComponent from '../../modules/surveyanalytics/surveyanalytics'
import SurveyTableComponent from '../../modules/surveyanalytics/surveyanalyticstable'

const SurveyResultLecturer = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const state: any = location.state

    const [surveyResults, setSurveyResults] = React.useState<object[]>()
    const [survey, setSurvey] = React.useState('')


    useEffect(() => {
        if (state) {
            getSemesterCourseReport(`filter_semesterCourse_id=${state.id}`,"Name,SemesterCourse.SemesterId as SemesterId","SemesterCourse").then((res: any) => {
                console.log(res.data[0].name)

                setSurveyResults([JSON.parse(res.data[0].name)])
                getSurvey(`filter_surveyType_id=7&filter_semester_id=${res.data[0].semesterId}`, 'Id,Guid,SurveyJson').then((surveyResponse: any) => {
                    const surveyJson = JSON.parse(surveyResponse.data[0].surveyJson);
                    // Yeni oluşturulan elementleri mevcut elements dizisine ekle
                    // surveyJson.pages[0].elements.push(...newElements);
                    //console.log(surveyJson)
                    // Güncellenmiş surveyJson ile setSurvey fonksiyonunu çağır
                    setSurvey(surveyJson);
                    console.log(surveyJson);
                })
            })
            //todo: id sabitten çıkartılmalı
            

            //getStudentSemesterCourse(`filter_semesterCourse_id=${state.id}&items_per_page=9999`, 'Id,SurveyApplication*Name,SurveyApplication*SurveyId,SurveyApplication*Id', 'SurveyApplication').then((res: any) => {
            //    //console.log(res)
            //    //setSurveyResults()
            //    const surveyid = res.data.filter((a: any) => a.surveyApplicationName.length > 0)[0].surveyApplicationSurveyId[0]
            //    const validSaids = res.data.filter((a: any) => a.surveyApplicationId[0] !== undefined).map((a: any) => a.surveyApplicationId[0]);
            //    getSurveyApplication(`filter__id=${validSaids.join(',')}&items_per_page=9999`, 'Id,SurveyApplicationCourseOutcome*Point,SurveyApplicationCourseOutcome*CourseOutcomeId','SurveyApplicationCourseOutcome').then((a: any) => {
            //        //console.log(a.data)
            //        getCourseOutcome(`filter__id=${a.data[0].surveyApplicationCourseOutcomeCourseOutcomeId.join(',')}`).then((resco: any) => {
                        
            //            const surveyResultsC = res.data.filter((a: any) => a.surveyApplicationName.length > 0).map((a: any) => {
            //                const parsedJson = JSON.parse(a.surveyApplicationName);
            //                parsedJson.surveyApplicationId = a.surveyApplicationId[0];  // ID'yi JSON'a ekleyin
            //                return parsedJson;
            //            });
            //            //console.log(surveyResultsC)
            //            const enrichedSurveyResults = surveyResultsC.map((surveyRes: any) => {
            //                const surveyApp = a.data.find((app: any) => app.id === surveyRes.surveyApplicationId);
            //                //console.log(surveyApp);
            //                //console.log(a.data);
            //                if (surveyApp) {
            //                    surveyApp.surveyApplicationCourseOutcomeCourseOutcomeId.forEach((id: any, index: any) => {
            //                        surveyRes['oc_' + id] = surveyApp.surveyApplicationCourseOutcomePoint[index];
            //                    });
            //                }
            //                return surveyRes;
            //            });

            //            // İşlenmiş ve zenginleştirilmiş verileri setSurveyResults'a göndermek
            //            setSurveyResults(enrichedSurveyResults);

            //            console.log(resco.data)
            //            //console.log(a.data)
            //            const newElements = resco.data.map((co: any) => ({
            //                type: "rating",
            //                name: 'oc_'+co.id.toString(), // CourseOutcomeId kullanılarak name atanır
            //                title: co.name, // CourseOutcome name kullanılarak title atanır
            //                rateCount: 10,
            //                rateMax: 10
            //            }));

            //            getSurvey(`filter__id=${surveyid}`, 'Id,Guid,SurveyJson').then((surveyResponse: any) => {
            //                const surveyJson = JSON.parse(surveyResponse.data[0].surveyJson);
            //                // Yeni oluşturulan elementleri mevcut elements dizisine ekle
            //                surveyJson.pages[0].elements.push(...newElements);
            //                //console.log(surveyJson)
            //                // Güncellenmiş surveyJson ile setSurvey fonksiyonunu çağır
            //                setSurvey(surveyJson);
            //            })
            //        })
            //    })
            //    console.log(validSaids)
                
            //    console.log(surveyid)
            //})

            //console.log(state)
        }
    }, [state])

    useEffect(() => {
        console.log(surveyResults)
    }, [surveyResults])

    return (
        <>
            {survey !== '' && surveyResults && <div><SurveyResultsComponent surveyJson={survey} surveyData={surveyResults} /><SurveyTableComponent surveyJson={survey} surveyData={surveyResults} /></div>}
        </>
    )
}


export default SurveyResultLecturer